import styled, { css } from "styled-components";
import SearchBox from "./search-box";

const open = css`
  width: 100%;
  background: ${({ theme }) => theme.background};
  cursor: text;
  border: none;
  margin-left: 0;
  padding-left: 1em;
  padding-right: 2.6em;
  padding-bottom: 8px;
  padding-top: 8px;
  border-radius: 20px;
  font-size: 1.1em;
  ::placeholder {
    color: black;
  }
`;

const closed = css`
  width: 100%;
  background: #6a70b2;
  border: none;
  cursor: pointer;
  font-size: 1.1em;
  margin-left: 0;
  padding-left: 1em;
  padding-right: 2.6em;
  padding-bottom: 8px;
  padding-top: 4px;
  color: antiquewhite;
  border-radius: 20px;
`;

export default styled(SearchBox)`
  position: relative;
  display: block;
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
  margin-bottom: 0;
  min-height: 40px;
  text-align: start;

  .SearchInput {
    width: 100%;
    outline: none;
    font-size: 1em;
    transition: 100ms;
    color: ${({ theme }) => theme.foreground};
    ::placeholder {
      color: ${({ theme }) => theme.faded};
    }
    ${({ hasFocus }) => (hasFocus ? open : closed)}
  }
`;
